import { Navigate } from 'react-router';
import { RETURN_TO_KEY } from './auth-context';

/** Browser sign-in lands here; supabase-js has already finished it by the time we render. */
export function AuthCallback() {
  let to = '/';
  try {
    const saved = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    if (saved?.startsWith('/') && !saved.startsWith('//')) to = saved;
  } catch {
    // Home it is.
  }
  return <Navigate to={to} replace />;
}
